import { css } from 'styled-components';
import { Fonts } from './fonts';
import { Elements } from './elements';
import { Layout } from './layout';
import { Forms } from './forms';

// DO NOT use this unless you have checked what the page looks/functions like
// after requesting the page with JS disabled in your browser.

const lightningModeBase = css`
  body.ready,
  body.ready html {
    overflow-x: unset;
  }

  img {
    max-width: 100%;
  }
`;

const lightningModeOn = css`
  body {
    opacity: 1 !important;
  }
`;

const pdpModule = css`
  .site-content > .container {
    max-width: 100%;
    padding: 0;
  }

  .tableel th {
    font-weight: inherit;
  }
`;

export const LightningMode = ({
  disabled = false,
  includeLayout = false,
  includeForms = false,
  includePdpModule = false,
}) => css`
  ${lightningModeBase}
  ${Fonts}
  ${includeForms ? Forms : ''}
  ${includeLayout ? Layout : ''}
  ${Elements}

  ${!disabled ? lightningModeOn : ''}
  ${includePdpModule ? pdpModule : ''}
`;
